import { ApiError, api } from "@/lib/api";

/** 品牌工具设置（含 Journey 默认旅程偏好） */
export type BrandToolSettings = {
  id: number;
  brand_id: number;
  product: string;
  name: string;
  /** c456-journey 旅程 ID；null = 不绑定；入队尚未上线 */
  default_journey_id: number | null;
};

export type BrandToolShowPayload = {
  product: string;
  brand_id: number;
  tool_enabled: boolean;
  tool: BrandToolSettings | null;
};

function toolPath(accountId: string | number, brandId: string | number, product: string) {
  return `/accounts/${accountId}/brands/${brandId}/tools/${encodeURIComponent(product)}`;
}

/** 读取品牌某工具设置 */
export function fetchBrandTool(
  accountId: string | number,
  brandId: string | number,
  product: string,
) {
  return api.fetchForAccount<BrandToolShowPayload>(accountId, toolPath(accountId, brandId, product));
}

/** 更新品牌工具设置（如默认旅程） */
export function updateBrandTool(
  accountId: string | number,
  brandId: string | number,
  product: string,
  body: { default_journey_id: number | null },
) {
  return api.fetchForAccount<{ tool: BrandToolSettings }>(accountId, toolPath(accountId, brandId, product), {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}

export { ApiError };
